export const accred = {
  accreditation: `Accreditation`,
  checkAll: `Check all that apply:`,
}
